import { CERTIFICADO_INFOS, VALIDACAO_MSG, VALIDACAO_STATUS, VALIDACAO_UNICA } from '../logicas/Validador/ValidadorApi';

export function validacaoReducer(state={},action){
  switch (action.type){
    case VALIDACAO_STATUS:
      return {...state, status:action.payload};
    case VALIDACAO_MSG:
      return {...state, msg:action.payload};
    case CERTIFICADO_INFOS:
      return {...state, certificadoInfos:action.payload};
    case VALIDACAO_UNICA:
      return {...state, statusUnique:action.payload};
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/validacaoReducer.js